import React, { useCallback, useState } from "react";

let gradesKey = 0;
let tagsKey = 0;
const Student = ({ addNewTag, studentDetails }) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [newTag, setNewTag] = useState("");

  const viewGradesToggler = useCallback(() => {
    setIsAccordionOpen(!isAccordionOpen);
  }, [isAccordionOpen]);

  const addTagOnchange = useCallback(
    (e) => {
      setNewTag(e.target.value);
    },
    [setNewTag]
  );

  const addTagOnSubmit = useCallback((e) => {
    const { id } = studentDetails;
    e.preventDefault();
    addNewTag(newTag, id);
    setNewTag("");
  },[newTag,addNewTag,studentDetails]);

  const {
    id,
    firstName,
    lastName,
    email,
    company,
    skill,
    grades,
    tags,
    pic,
    averageScore,
  } = studentDetails;

  return (
    <React.Fragment>
      <div className="container-fluid mt-2 student">
        <div className="row">
          <div className="col-3 text-center">
            <img
              className="student-profileImg rounded-circle mt-4"
              src={pic}
              alt={"student " + id + " photo"}
            />
          </div>
          <div className="col-9">
            <h3>
              {firstName} {lastName}
            </h3>
            <ul
              className="student-personalInfo"
            >
              {/*line-height has to be set inline to be effective for now.
              an unknown css rule would overide it if we use an external style*/}
              <li style={{lineHeight: "1.3em"}}>
                <span>Email:</span> {email}
              </li>
              <li style={{lineHeight: "1.3em"}}>
                <span>Company:</span> {company}
              </li>
              <li style={{lineHeight: "1.3em"}}>
                <span>Skill:</span> {skill}
              </li>
              <li style={{lineHeight: "1.3em"}}>
                <span>Average:</span> {averageScore}
              </li>
            </ul>
            <div className="panel-group">
              <div className="panel panel-default">
                <div className="panel-heading">
                  {isAccordionOpen === true ? (
                    <a
                      onClick={viewGradesToggler}
                      className="student-gradesListToggleBtn"
                      data-toggle="collapse"
                      href={"#collapse" + id}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" />
                      </svg>
                    </a>
                  ) : (
                    <a
                      onClick={viewGradesToggler}
                      className="student-gradesListToggleBtn"
                      data-toggle="collapse"
                      href={"#collapse" + id}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" />
                      </svg>
                    </a>
                  )}
                </div>
                <div id={"collapse" + id} className="panel-collapse collapse">
                  <ul className="list-group student-gradesList">
                    {grades.map((grade) => (
                      <li key={++gradesKey} className="list-group-item">
                        Test
                        {grades.indexOf(grade) + 1}: {"   "}
                        {grade}
                        {"%"}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <ul className="student-tagsList">
              {tags.map((tag) => (
                <li key={++tagsKey} className="mb-2">
                  <span className="badge student-tag p-2">
                    {tag}
                  </span>
                </li>
              ))}
            </ul>

            <form action="#" onSubmit={addTagOnSubmit}>
              <input
                id={id}
                className="student-addTag"
                type="text"
                value={newTag}
                onChange={addTagOnchange}
                placeholder="Add a tag"
              />
            </form>
          </div>
        </div>
      </div>
      <div style={{ border: ".5px solid 	rgb(241, 240, 240)" }}></div>
    </React.Fragment>
  );
};
export default Student;
